// extracted by css-extract-rspack-plugin
export default {"container":"bTj63","like":"kAPDR","dislike":"R3AW4","selected":"kSXU7","label":"HvQdv"};